import script from "./StationDuration.vue?vue&type=script&setup=true&lang=js"
export * from "./StationDuration.vue?vue&type=script&setup=true&lang=js"

import "./StationDuration.vue?vue&type=style&index=0&id=0a958687&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a958687"]])

export default __exports__